import React, { Fragment } from 'react';
import TitleBox from '../../components/common/TitleBox';
import SlotCenter from '../../components/Slot/SlotCenter';
import SlotRight from '../../components/Slot/SlotRight';

const Slot = () => {
    return (
        <Fragment>
            <TitleBox title="슬롯"/>
            <div className="contents_wrap">
                <SlotCenter type="Slot"/>
            </div>
        </Fragment>
    );
};

export default Slot;


// WEBPACK FOOTER //
// ./src/containers/Slot/Slot.js